module.exports = __webpack_public_path__ + "static/media/M.a41bf903.jpg";